export * from './ApiUrls'



// WEBPACK FOOTER //
// ./src/legacy/containers/ApiUrls/index.js